import {
  Autocomplete as MUIAutocomplete,
  AutocompleteProps as MUIAutocompleteProps,
} from '@mui/material';
import React from 'react';

export const Autocomplete: React.FC<
  MUIAutocompleteProps<string, false, true, false>
> = React.forwardRef((props, ref) => {
  const { options, ...otherProps } = props;

  return (
    <MUIAutocomplete
      {...otherProps}
      options={options}
      disableClearable
      ref={ref}
      sx={{
        fontSize: '1rem',
        fontStyle: 'normal',
        '& .MuiOutlinedInput-root': {
          p: 0,
          pl: 1,
        },
        '.MuiAutocomplete-endAdornment': {
          backgroundColor: 'transparent',
        },
      }}
    />
  );
});
